"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDynamicPartInputSelectorValues = exports.elementTreeSelectors = void 0;
function elementTreeSelectors(elements) {
    var selectors = [];
    var walkTree = function (root, parentSelector) {
        Object.keys(root).forEach(function (node) {
            var currSelector = parentSelector ? "".concat(parentSelector, "::").concat(node) : node;
            selectors.push(currSelector);
            walkTree(root[node], currSelector);
        });
    };
    walkTree(elements);
    return selectors;
}
exports.elementTreeSelectors = elementTreeSelectors;
function getDynamicPartInputSelectorValues(selectorValues, dynamicPart) {
    return Object.keys(selectorValues).reduce(function (outputSelectorValues, selector) {
        var controllerSelector = selectorValues[selector];
        var controllerMatch = controllerSelector.controllersMatch.find(function (controller) { return controller.name === dynamicPart; });
        if (controllerMatch) {
            outputSelectorValues[selector] = {
                params: controllerMatch.params,
                decls: controllerSelector.decls,
            };
        }
        return outputSelectorValues;
    }, {});
}
exports.getDynamicPartInputSelectorValues = getDynamicPartInputSelectorValues;
//# sourceMappingURL=controller-part-utils.js.map